<script setup lang="ts">
import { useSeoHead } from "@/composables/use-seo-head";
import SiteHero from "@/components/sections/site-hero.vue";
import SocialProof from "@/components/sections/social-proof.vue";
import ProblemSection from "@/components/sections/problem-section.vue";
import SolutionBridge from "@/components/sections/solution-bridge.vue";
import StorybookSection from "@/components/sections/storybook-section.vue";
import WhyCresci from "@/components/sections/why-cresci.vue";
import FeatureBlocks from "@/components/sections/feature-blocks.vue";
import ThemeCarousel from "@/components/sections/theme-carousel.vue";
import TestimonialSection from "@/components/sections/testimonial-section.vue";
import PricingSection from "@/components/sections/pricing-section.vue";
import DeviceSection from "@/components/sections/device-section.vue";
import FaqSection from "@/components/sections/faq-section.vue";
import FinalCta from "@/components/sections/final-cta.vue";

useSeoHead("home");
</script>

<template>
  <SiteHero />
  <SocialProof />
  <ProblemSection />
  <SolutionBridge />
  <StorybookSection />
  <WhyCresci />
  <FeatureBlocks />
  <ThemeCarousel />
  <TestimonialSection />
  <PricingSection />
  <DeviceSection />
  <FaqSection />
  <FinalCta />
</template>
